import styled from 'styled-components';
import PlayText from '../../ui-components/typography/PlayText/PlayText';
import { device } from '../../ui-components/breakpoints';

export const StyledDescription = styled(PlayText)`
    max-width: 40em;
    margin-bottom: 40px;

    @media ${device.GteMedium} {
        margin-bottom: 50px;
    }
`;
